import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Dropdown } from "../dropdown";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var NavMenuItem = React.forwardRef(function NavMenuItem(_a, ref) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? "default" : _c, selected = _a.selected, className = _a.className, overlay = _a.overlay, children = _a.children, props = __rest(_a, ["type", "selected", "className", "overlay", "children"]);
    var classPrefix = useConfig().classPrefix;
    var wrapperProps = __assign({ className: classNames(className, (_b = {},
            _b[classPrefix + "-nav__service"] = type === "default",
            _b[classPrefix + "-nav__logo"] = type === "logo",
            _b[classPrefix + "-nav__dropdown"] = type === "dropdown",
            _b[classPrefix + "-nav__operation"] = type === "icon",
            _b["is-selected"] = selected,
            _b)) }, props);
    if (type === "dropdown") {
        return (React.createElement("div", __assign({ ref: ref }, wrapperProps),
            React.createElement(Dropdown, { trigger: "hover", button: children, clickClose: false, boxClassName: classPrefix + "-nav__dropdown-box", placementOffset: 0 }, overlay)));
    }
    if (type === "icon") {
        return (React.createElement("div", __assign({ ref: ref }, wrapperProps),
            React.createElement("a", { className: classPrefix + "-nav__operation-inner" }, children)));
    }
    if (type === "logo") {
        return (React.createElement("div", __assign({ ref: ref }, wrapperProps),
            React.createElement("a", null, children)));
    }
    // default
    if (typeof children === "string") {
        return (React.createElement("div", __assign({ ref: ref }, wrapperProps),
            React.createElement("a", { className: classNames({ "is-selected": selected }) }, children)));
    }
    return (React.createElement("div", __assign({ ref: ref }, wrapperProps), children));
});
NavMenuItem.displayName = "NavMenuItem";
export var NavMenu = forwardRefWithStatics(function NavMenu(_a, ref) {
    var left = _a.left, right = _a.right, className = _a.className, props = __rest(_a, ["left", "right", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("nav", __assign({ ref: ref, className: classNames(classPrefix + "-nav", className) }, props),
        left,
        React.createElement("div", { className: classPrefix + "-nav__flex-end" }),
        right));
}, {
    Item: NavMenuItem,
});
NavMenu.displayName = "NavMenu";
//# sourceMappingURL=NavMenu.js.map